export const invitationPresentation = (state) => {
  switch (state) {
    case 'offline':
      return {
        eyebrow: 'CONNECTION PAUSED',
        title: 'You seem to be offline',
        body: 'Your invitation is still private. Reconnect, then try again.',
        action: 'Try again',
      };
    case 'unsupported':
      return {
        eyebrow: 'CONTINUE ON YOUR PHONE',
        title: 'This invitation needs a mobile device',
        body: 'Open this same private link on your phone to continue in LifeTagger.',
        action: null,
      };
    case 'expired':
      return {
        eyebrow: 'THIS INVITATION HAS FADED',
        title: 'This link has expired',
        body: 'Ask the person who invited you to send a new private invitation.',
        action: null,
      };
    case 'claimed':
      return {
        eyebrow: 'ALREADY RECEIVED',
        title: 'This invitation was already claimed',
        body: 'Open LifeTagger with the account that received it to return to the Moment.',
        action: 'Open LifeTagger',
      };
    case 'invalid':
      return {
        eyebrow: 'INVITATION UNAVAILABLE',
        title: 'This link cannot be used',
        body: 'It may have been replaced or removed. No private information was shared.',
        action: null,
      };
    default:
      return {
        eyebrow: 'A PRIVATE LIFETAGGER INVITATION',
        title: 'Someone left something for you',
        body: 'A Moment is waiting for you in LifeTagger. Only the person it was left for can open it.',
        action: 'Open in LifeTagger',
      };
  }
};

export const invitationDeviceState = (userAgent = '') =>
  /android|iphone|ipad|ipod/i.test(userAgent) ? 'supported' : 'unsupported';

export const mobileStoreUrl = (userAgent = '') =>
  /android/i.test(userAgent)
    ? process.env.REACT_APP_ANDROID_STORE_URL ||
      'https://play.google.com/store/apps/details?id=com.parse.lifetagger'
    : process.env.REACT_APP_IOS_STORE_URL ||
      'https://apps.apple.com/us/app/lifetagger/id1194576774';
